import api from '../store/apiClient';

export async function getContentByType(type) {
  const { data } = await api.get(`/content/${encodeURIComponent(String(type || '').trim())}`);
  return data?.data ?? null;
}
